import { useMemo, memo } from 'react'
import { JobCard } from '@/components/JobCard'
import { Job } from '@/components/JobCard'

interface VirtualizedJobListProps {
  jobs: Job[]
  viewMode: 'grid' | 'list'
  isLoading?: boolean
}

// Memoized job item to prevent unnecessary re-renders
const MemoizedJobCard = memo(JobCard)

export const VirtualizedJobList = memo(({ jobs, viewMode, isLoading }: VirtualizedJobListProps) => {
  // Memoize the job cards to prevent unnecessary re-renders
  const jobCards = useMemo(() => {
    return jobs.map((job) => (
      <MemoizedJobCard 
        key={job.id} 
        job={job} 
        variant={viewMode}
      />
    ))
  }, [jobs, viewMode])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (viewMode === 'grid') {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8 items-stretch">
        {jobCards}
      </div>
    )
  }

  return (
    <div className="space-y-4 mb-8">
      {jobCards}
    </div>
  )
})

VirtualizedJobList.displayName = 'VirtualizedJobList'